import { render, staticRenderFns } from "./AddDocumentOrdersModal.vue?vue&type=template&id=4c096697"
import script from "./AddDocumentOrdersModal.vue?vue&type=script&lang=js"
export * from "./AddDocumentOrdersModal.vue?vue&type=script&lang=js"
import style0 from "./AddDocumentOrdersModal.vue?vue&type=style&index=0&id=4c096697&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports